<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="title">
                        {{ campaignCode }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in globalSideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { CAMPAIGN_SIDEMENU } from '@/store/types'

export default {
  data() {
    return {
      breadcrumb: [],
      sideMenu: [
        { name: 'campaignReview', text: 'Campaign', icon: 'mdi-calendar-clock' }
      ],
      newCampaign: false
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    title() {
      if (this.newCampaign) {
        return 'New Campaign'
      } else {
        return 'Review Campaign'
      }
    },
    globalSideMenu() {
      return this.$store.state.promotionManagement.campaign.sideMenu
    },
    campaignCode() {
      if (this.campaign) {
        return this.campaign
      } else {
        return 'New Campaign'
      }
    }
  },
  methods: {
    ...mapActions([
      'campaignInit'
    ]),
    async doInit() {
      if (!this.newCampaign) {
        await this.campaignInit(this.campaign)
        if (!this.$store.state.promotionManagement.campaign.allIntermediary) {
          this.sideMenu.push({ name: 'intermediaryCampaignReview', text: 'Intermediaries', icon: 'mdi-account' })
        }
      }
      this.$store.commit(CAMPAIGN_SIDEMENU, this.sideMenu)
    }
  },
  props: {
    campaign: {
      type: String,
      default: ''
    }
  },
  beforeMount() {
    if (this.campaign === 'New') {
      this.newCampaign = true
    } else {
      this.sideMenu.push({ name: 'campaignPromotionReview', text: 'Promotions', icon: 'mdi-star' })
      this.sideMenu.push({ name: 'productCampaignReview', text: 'Products', icon: 'mdi-cube-outline' })
    }
    // Manual breadcrumb
    this.breadcrumb = this.derieveBreadcrumbByName('campaigns')
    this.breadcrumb.push({
      name: 'campaignReview',
      text: this.title
    })
  }
}
</script>

<style lang="scss">
</style>
